import React from "react";
import StaticHero from "../components/StaticHero";
import Ticker from "../components/Ticker";
import WelcomeSection from "../components/WelcomeSection";
import StatsBar from "../components/StatsBar";
import Certifications from "../components/Certifications";
import ProcessSection from "../components/ProcessSection";
import ProductSpotlight from "../components/ProductSpotlight";
import WhyChooseUs from "../components/WhyChooseUs";
import ProductsGrid from "../components/ProductsGrid";
import Testimonials from "../components/Testimonials";
import CtaCallback from "../components/CtaCallback";
import IndustriesWeDealIn from "../components/IndustriesWeDealIn";
import Gallery from "../components/Gallery";
import useSeo from "../hooks/useSeo";

export default function Home() {
  useSeo({
    title: "Industrial & Shortwave IR Heaters Manufacturer",
    description: "ISO 9001:2015 certified manufacturer of industrial heaters & shortwave infrared heating elements. 25+ years of engineering excellence. Trusted by 1000+ clients.",
    keywords: "shortwave IR heater, infrared heater manufacturer, industrial heating elements, reflector box heater, ISO 9001 heater, OEM heating",
    path: "/",
  });
  return (
    <main>
      <StaticHero />
      <Ticker />
      <WelcomeSection />
      <StatsBar />
      <Certifications />
      <ProcessSection />
      <ProductSpotlight />
      <WhyChooseUs />
      <ProductsGrid />
      <Testimonials />
      <CtaCallback />
      <IndustriesWeDealIn />
      <Gallery />
    </main>
  );
}
